import { useTranslation } from 'react-i18next'
import type { Animal, LostReport } from '../types/models'

type CaseItem = LostReport & { animal: Animal }

interface Props {
  open: boolean
  items: CaseItem[]
  selectedAnimalId: number | null
  onSelect: (animalId: number) => void
  onClose: () => void
}

export function CasePanel({ open, items, selectedAnimalId, onSelect, onClose }: Props) {
  const { t } = useTranslation()

  return (
    <aside className={`side-panel${open ? ' open' : ''}`} aria-label={t('panel.title')}>
      <div className="panel-header">
        <div className="panel-kicker">// {t('panel.title')}</div>
        <h2 className="panel-title">{t('panel.lostTitle')}</h2>
        <button type="button" className="btn btn-ghost" style={{ marginTop: '0.5rem' }} onClick={onClose}>
          {t('panel.closePanel')}
        </button>
      </div>
      <div className="panel-body">
        {items.length === 0 ? (
          <p className="empty-state">{t('panel.emptyLost')}</p>
        ) : (
          items.map((item) => {
            const a = item.animal
            return (
              <article
                key={item.id}
                className={`case-card${selectedAnimalId === a.id ? ' active' : ''}`}
                onClick={() => onSelect(a.id)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') onSelect(a.id)
                }}
                role="button"
                tabIndex={0}
              >
                <div className="case-id">
                  CASE-{String(a.id).padStart(4, '0')} · {t(`types.${a.type}`)}
                </div>
                <div className="case-meta">
                  {t(`colors.${a.color1}`)}
                  {a.color2 ? ` / ${t(`colors.${a.color2}`)}` : ''}
                  <small>
                    {a.chip ? `${t('fields.chip')}: ${a.chip}` : t('fields.unknown')}
                    {' · '}
                    {item.contact_info}
                  </small>
                </div>
              </article>
            )
          })
        )}
      </div>
    </aside>
  )
}
